import React from 'react';
import { Paper } from '@mui/material';
import clsx from 'clsx';
import { MessageBoxProps } from './MessageBox.props';
import MessageBoxIcon from './MessageBoxIcon';

const MessageBox = ({
  title,
  tagline,
  type = 'info',
  action,
  secondaryAction,
  fullWidth = true,
  hasFrame = true,
  showIcon = true,
  hasBgColor = false,
  titleStyleOverride,
}: MessageBoxProps) => (
  <div
    className={clsx(
      'message-box',
      hasFrame && 'message-box--with-frame',
      type && `message-box--${type}`,
      fullWidth && 'message-box--full-with',
      hasBgColor && 'message-box--with-bg-color'
    )}>
    <Paper elevation={hasFrame ? 2 : 0} className="message-box__container">
      {showIcon && <MessageBoxIcon type={type} />}
      <h3 className="message-box__title" style={titleStyleOverride}>
        {title}
      </h3>
      <p className="message-box__tagline">{tagline}</p>
      {action}
      {secondaryAction}
    </Paper>
  </div>
);

export default MessageBox;
